const NUTRITION_COMPUTED_DIET_TAGS = [
  'Low carb',
  'Low sugar',
  'Low fat',
  'High protein',
  'High fibre',
  'Keto',
  'Very low sodium',
  'Low sodium',
  'Diabetic',
  'Heart health',
  'Low calorie',
];

export default NUTRITION_COMPUTED_DIET_TAGS;
